// extracted by mini-css-extract-plugin
module.exports = {"editingButtonsFieldset":"HandBookEditButton_editingButtonsFieldset__3PqWO","editingButtonsLegend":"HandBookEditButton_editingButtonsLegend__13AbX"};